import React, { useState } from "react";

import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import "./Pagination.css";

const Pagination = (props) => {

  //Props
  //const IsDesktop = props.IsDesktop;
  const Data = props.data;

  //State
  const [page, setPage] = useState(props.data.page);

  //Clique sur les flèches des pages
  const onClickPage = (e) => {
    const currentPage = parseInt(e.currentTarget.dataset.page);
    const total = Math.ceil(props.count / props.data.perPage);


    if (currentPage > total || currentPage < 1)
      return;

    //setPage(currentPage);
    props.onChangePage(currentPage);

  };

  //Changer la valeur du nombre de page par l'input
  const onChangeInput = (e) => {


    let currentPage = parseInt(e.target.value);
    const total = Math.ceil(props.count / props.data.perPage);

    if (isNaN(currentPage)) return;
    if (currentPage <= 0 || currentPage > total) return;


    setPage(e.target.value);
    props.onChangePage(currentPage);
  };

  //Sortir de la case input
  const onBlurInput = () => {

    let currentPage;
    const total = Math.ceil(props.count / props.data.perPage);

    if (isNaN(page)){
      currentPage = props.data.page;
    }else if (page < 1){
      currentPage = 1;
    }else if (page > total){
      currentPage = total;
    }else{
      currentPage =  page;
    }
    
    setPage(parseInt(currentPage));
    props.onChangePage(parseInt(currentPage));

  }


  //Render
  return (
    <div className="pagination_cont">
      <div
        className="pagination_button"
        style={{ borderTopLeftRadius: "10px", borderBottomLeftRadius: "10px" }}
        data-page={props.data.page - 1}
        onClick={onClickPage}
      >
        <MdChevronLeft />
      </div>
      <div className="pagination_input_cont">
        <input
          className="pagination_input"
          type="text"
          value={Data.page}
          onChange={onChangeInput}
          onBlur={onBlurInput}
        />
      </div>
      <div
        className="pagination_button"
        style={{ borderTopRightRadius: "10px", borderBottomRightRadius: "10px" }}
        data-page={props.data.page + 1}
        onClick={onClickPage}
      >
        <MdChevronRight />
      </div>
    </div>);

};

export default Pagination;
